import invariant from 'invariant';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

/**
 * UploadLinkPublicPage
 *
 * Public, unauthenticated upload route (outside the main app).
 * /upload/:uploadLinkId
 */
type UploadLinkPublicPage = {
  page: 'uploadLinkPublic';
  uploadLinkId: string;
};

export type UploadLinkPublicGetLinkParams = UploadLinkPublicPage;

export const getLinkForUploadLinkPublic = (
  params: UploadLinkPublicGetLinkParams
): ValidHref => {
  invariant(params.uploadLinkId, 'uploadLinkId is required');

  if (params.page === 'uploadLinkPublic') {
    return createUrl({ pathname: `/upload/${params.uploadLinkId}` });
  }

  throw new Error('Not implemented');
};

export const isUploadLinkPublicPageType = (href: ValidHref): boolean => {
  const parts = getPathnameFromHref(href).split('/');

  // /upload/:uploadLinkId
  return parts[1] === 'upload' && Boolean(parts[2]);
};
